// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2dlgd","info":"UpdateTermsInfo_info__1USDf"};